import {fetch} from "utils/dataAccess";

function toFloatWeight(weight) {
    if (typeof weight !== "string") {
        return weight;
    }

    return parseFloat(weight.replace(",", "."));
}

export default async function ship(shipment, toShipObject = {})  {
    const body = "weight" in toShipObject
        ? {...toShipObject, weight: toFloatWeight(toShipObject.weight)}
        : toShipObject;

    const response = await fetch(`/shipments/${shipment.id}/ship`, {
        method: "POST",
        body: JSON.stringify(body),
    });

    return await response.json();
}
